import React from "react";
import { Helmet } from "react-helmet";

export type ResultsProps = {
  status?: string;
  listName?: string;
  resultMsg: string;
  modifyUrl?: string;
  subscriptionUrl?: string;
  paymentUrl?: string;
};

export default function Results(props: ResultsProps) {
  
  const { status, listName, resultMsg, modifyUrl, subscriptionUrl, paymentUrl } = props;

  return (
    <>
      <Helmet>
        <title>{listName}</title>
      </Helmet>
        <div className={`subscription_result ${status}`}>
          <div className="result-frame">
            <h1>{listName}</h1>
            {status === 'Confirm' &&
            <span className="icon-confirm"></span>
            }
            {status === 'NonConfirm' &&
            <span className="icon-success"></span>
            }
            <p>{resultMsg}</p>
            {modifyUrl && (
              <p>
                <a href={modifyUrl}>구독 정보 변경하기</a>
              </p>
            )}
            {paymentUrl && (
              <p>
                <a href={paymentUrl}>결제 정보 다시 입력하기</a>
              </p>
            )}
            {subscriptionUrl && (
              <p>
                <a href={subscriptionUrl}>구독하기</a>
              </p>
            )}
          </div>
        </div>
    </>
  );
}
